import React from 'react';
import { Box, Paper, Skeleton, Stack } from '@/shared/ui';

const DetailPageSkeleton: React.FC = () => (
  <Stack spacing={2}>
    {[0, 1, 2].map((section) => (
      <Paper key={section} variant="outlined" elevation={0} sx={{ p: 2.5 }}>
        <Skeleton variant="text" width={160} height={28} sx={{ mb: 2 }} />
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
            gap: 2,
          }}
        >
          {Array.from({ length: section === 2 ? 2 : 4 }, (_, i) => (
            <Box key={i}>
              <Skeleton variant="text" width={88} height={16} sx={{ mb: 0.5 }} />
              <Skeleton variant="rounded" height={20} width={`${60 + ((section + i) % 3) * 15}%`} />
            </Box>
          ))}
        </Box>
      </Paper>
    ))}
  </Stack>
);

export default DetailPageSkeleton;
